import {useContext} from "react";
import QRCodeStyleViewContext from "../../QRCodeStyleViewContext";
import {Button} from "@mantine/core";
import QRCodeStyleDialogContext from "../../../QRCodeStyleDialogContext";
import Notifications from "../../../../../../../utils/notifications/Notifications";

function SaveButton() {
    /**
     * QRCodeStyleViewContext
     * @since 0.1.9
     * @author Kacper Faber
     */
    const ctx = useContext(QRCodeStyleViewContext);

    /**
     * Close function from QRCodeStyleDialogContext.
     * Will close the dialog.
     * @since 0.1.9
     * @author Kacper Faber
     */
    const {close} = useContext(QRCodeStyleDialogContext);

    // /**
    //  * Throws an error that informs us about QRCode [image] is not really updated.
    //  * @since 0.1.9
    //  * @author Kacper Faber
    // */
    // const warnUser = () => {};

    /**
     * On button is clicked
     * @since 0.1.9
     * @author Kacper Faber
     */
    const onClick = () => {
        ctx.save()
            .then(close)
            .catch(Notifications.onCreateFailed);
    };

    return (
        <Button
            mb="xl"
            tt="uppercase"
            size="lg"
            mx="md"
            onClick={onClick}
            children="Zapisz"
        />
    )
}

export default SaveButton;